import { Link } from "react-router-dom";
import { House, Sparkles, Shapes, ChevronDown, ArrowUpRight } from "lucide-react";
const GROUPS=[
 {name:"Casa & dia a dia",icon:House,slugs:["casa","organizacao","decoracao","ferramentas","utilidades-domesticas","para-casa"]},
 {name:"Você & a família",icon:Sparkles,slugs:["beleza","brinquedos","pet","acessorios","presentes"]},
 {name:"Estudo & celebrações",icon:Shapes,slugs:["papelaria","festa","variedades"]}
];
export default function CategoryBrowser({categories=[],onSelect=()=>{}}){
 const known=GROUPS.flatMap(g=>g.slugs);
 const groups=[...GROUPS,{name:"Outros departamentos",icon:Shapes,slugs:categories.filter(c=>!known.includes(c.slug)).map(c=>c.slug)}];
 return <div className="grid gap-2 md:grid-cols-3" data-testid="category-browser">
  {groups.map(g=>{const items=categories.filter(c=>g.slugs.includes(c.slug)); if(!items.length)return null; const Icon=g.icon;
   return <details key={g.name} className="group rounded-xl border bg-white overflow-hidden">
    <summary className="list-none cursor-pointer flex items-center gap-3 p-4 font-semibold text-sm hover:bg-muted focus-visible:outline focus-visible:outline-primary">
     <Icon className="w-5 h-5 text-primary shrink-0"/><span className="flex-1">{g.name}<span className="block text-xs font-normal text-muted-foreground mt-1">{items.length} departamentos</span></span><ChevronDown className="w-4 h-4 group-open:rotate-180 transition"/>
    </summary>
    <div className="border-t p-2">{items.map(c=><Link key={c.id} to={"/produtos?cat="+encodeURIComponent(c.slug)} onClick={onSelect} className="flex items-center justify-between px-3 py-3 rounded-lg hover:bg-primary/5 text-sm" data-testid={"category-"+c.slug}>{c.name}<ArrowUpRight className="w-4 h-4 text-primary"/></Link>)}</div>
   </details>;
  })}
 </div>;
}
